require('../modules/es6.object.to-string');
require('../modules/es6.array.iterator');
require('../modules/es6.weak-map');
module.exports = require('../modules/_core').WeakMap;


//////////////////
// WEBPACK FOOTER
// C:/DEV/saaristonsiirin/~/core-js/es6/weak-map.js
// module id = ../../../../core-js/es6/weak-map.js
// module chunks = 0